<div
  class="flex flex-col tablet:flex-row justify-between items-start p-0 w-full mx-auto h-auto max-w-[1152px] desktop:flex-none desktop:order-3 desktop:self-stretch"
>
  <div
    id="mach-homepage-footer-links-container"
    *ngIf="content.footerColumn && content.footerColumn.length > 0"
    class="flex flex-col tablet:flex-row justify-between items-start p-0 w-full gap-6 tablet:gap-0"
  >
    <div
      #footerLinks
      *ngFor="let column of content.footerColumn; let i = index"
      [id]="'container-column-' + (1 + i)"
      class="flex flex-col items-start p-0 gap-16 w-full laptop:w-[220px] tablet:w-[167px] desktop:min-h-[308px] flex-none order-0"
    >
      <h3
        class="tablet:flex hidden w-auto h-5 text-label-md-semibold text-navigation"
      >
        {{ column.heading }}
      </h3>

      <!-- Mobile Accordion (375px) -->
      <div id="mobile-drawer" class="tablet:hidden block w-full">
        <details class="w-full">
          <summary
            [ngClass]="{
              'border-[#3a4351]': isBusiness || darkSiteTheme,
              'border-stroke-04': !isBusiness && !darkSiteTheme
            }"
            class="flex flex-row justify-between items-center py-16 w-full h-[57px] text-label-xs-semibold text-navigation cursor-pointer list-none border-b"
            [style.-webkit-tap-highlight-color]="'transparent'"
          >
            {{ column.heading }}
            <svg class="w-3 h-3" viewBox="0 0 12 12" fill="none">
              <path
                d="M2 4L6 8L10 4"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </summary>

          <ul class="block">
            <li *ngFor="let item of column.item">
              <a
                (click)="
                  setTrackingEvents(column.heading, item.itemName, $event)
                "
                [attr.href]="item.itemUrl"
                [attr.target]="item.newWindow ? '_blank' : ''"
                [attr.data-acdl-page-section]="
                  'footer:' + (column.heading | lowercase)
                "
                [attr.data-acdl-name]="item.itemName"
                [style.-webkit-tap-highlight-color]="'transparent'"
                class="nav-link-{{
                  item.itemName | lowercase
                }} inline-flex items-center py-8 px-0 text-label-xs-medium text-inverse no-underline hover:underline"
              >
                {{ item.itemName }}
                <svg
                  *ngIf="item.externalImage"
                  class="ml-4"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-label="open in new window"
                >
                  <g clip-path="url(#clip0_11646_283198)">
                    <path
                      d="M12 0V8.80078H10.3994V2.65625L1.13184 12.002L0 10.8604L9.18359 1.60059H3.19824V0H12Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_11646_283198">
                      <rect width="12" height="12" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </li>
          </ul>
        </details>
      </div>

      <!-- Tablet + List (above 375px) -->
      <ul
        class="tablet:flex hidden flex-col items-start p-0 gap-16 w-full laptop:w-[220px] tablet:w-[167px] list-none"
      >
        <li
          *ngFor="let item of column.item"
          class="w-full laptop:w-[220px] tablet:w-[167px] h-auto"
        >
          <a
            (click)="setTrackingEvents(column.heading, item.itemName, $event)"
            [attr.href]="item.itemUrl"
            [attr.target]="item.newWindow ? '_blank' : ''"
            [attr.data-acdl-page-section]="
              'footer:' + (column.heading | lowercase)
            "
            [attr.data-acdl-name]="item.itemName"
            [attr.data-acdl-action]="
              'footer:' + (column.heading | lowercase) + ':'
            "
            [style.-webkit-tap-highlight-color]="'transparent'"
            class="nav-link-{{
              item.itemName | lowercase
            }} flex flex-row items-center p-0 gap-1 w-full laptop:w-[220px] tablet:w-[167px] h-auto text-label-sm-medium text-inverse no-underline hover:underline"
          >
            {{ item.itemName }}
            <svg
              *ngIf="item.externalImage"
              class="my-[4px] ml-[4px]"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-label="open in new window"
            >
              <g clip-path="url(#clip0_11646_283198)">
                <path
                  d="M12 0V8.80078H10.3994V2.65625L1.13184 12.002L0 10.8604L9.18359 1.60059H3.19824V0H12Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_11646_283198">
                  <rect width="12" height="12" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
